<template>
    <svg
        xmlns="http://www.w3.org/2000/svg"
        display="block"
        viewBox="0 0 18 18"
    >
        <g transform="matrix(0.39966083,0,0,0.39966083,-3.796778,14.605642)">
            <path
                d="
                    m 9.5,-36.5 0,44.43 c 6.93,0 17.06,0.56 21.82,-11.48 3.1,-8.46 7.85,-12.58 16.95,-17.82 4.75,-3.68
                    5.88,-11.22 6.04,-15.12 z
                "
                :fill="fill"
            />
            <path
                d="
                    m 9.50845,7.371312 c 6.92445,0 16.536,0.579301 21.2901,-11.452331 3.1005,-8.466704 7.83393,
                    -12.633214 16.92873,-17.869202 4.7541,-3.676332 5.7876,-10.627941 5.735925,-14.538222
                "
                fill="#ffffff00"
                :stroke="stroke"
                stroke-width="1.5"
            />
        </g>
    </svg>
</template>

<script>
export default {
    props: {
        fill: {
            type: String,
            default: '#fff',
        },

        stroke: {
            type: String,
            default: '#000',
        },
    },
};
</script>
